import { groupHomeConstants } from 'srcReact/GroupHomePage'
import { myHomeConstants as mh } from 'srcReact/MyHomePage'

const initialState = {
  myMixrsLoading: false,
  myGroupsLoading: false,
  all: {
    loading: true,
    loaded: false,
    pagination: {
      nextOffset: 0,
      isPagination: false
    },
    stats: {
      total_mixrs_past: 0,
      total_mixrs_future: 0,
      total_groups: 0,
      total_mixrs_suggested: 0,
      total_groups_suggested: 0
    },
    future_mixr_list: [],
    past_mixr_list: [],
    group_list: [],
    suggested_mixr_list: [],
    suggested_group_list: [],
    mixr_invitations: {
      stats: {
        number_of_invites: 0
      },
      invites: []
    },
    group_invitations: {
      stats: {
        number_of_invites: 0
      },
      invites: []
    },
    moderation_info: {
      mixrs: {
        mixr_flag_count: 0,
        flagged_mixr_list: []
      },
      groups: {
        group_flag_count: 0,
        flagged_group_list: []
      },
      total_flag_count: 0
    },
    authUser: {
      id: 0,
      firstname: '',
      lastname: ''
    }
  },
  invitations: {
    loading: false,
    list: []
  }
}

export function myhome(state = initialState, action) {
  switch (action.type) {
    case mh.SET_GROUP_ROLE: {
      const mixrInvites = state.invitations.list?.length > 0 ? state.invitations.list[0].invites : null
      const updatedMixrInvites = mixrInvites?.map((m) => {
        if (m.group_id === action.groupId && action.joinedGroup.user_attending_status === 'joined') {
          m.groupe_attending = 1
        }
        return m
      })
      return {
        ...state,
        invitations: {
          ...state.invitations,
          list: [{ ...state.invitations.list[0], invites: updatedMixrInvites }, state.invitations.list[1]]
        }
      }
    }
    case mh.GET_MYHOME_ALL_REQUEST:
      return {
        ...state,
        all: {
          ...state.all,
          loading: true
        }
      }
    case mh.GET_MYHOME_ALL_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          stats: {
            ...state.all.stats,
            ...action.data.stats
          },
          future_mixr_list: action.data.future_mixr_list,
          past_mixr_list: action.data.past_mixr_list.sort(
            (a, b) => new Date(a.event_utc_start_datetime) - new Date(b.event_utc_start_datetime)
          ),
          group_list: action.data.group_list,
          suggested_group_list: action.data.suggested_group_list,
          suggested_mixr_list: action.data.suggested_mixr_list,
          mixr_invitations: {
            ...state.all.mixr_invitations,
            stats: {
              ...state.all.mixr_invitations.stats,
              ...action.data.mixr_invitations.stats
            },
            invites: action.data.mixr_invitations.invites
          },
          group_invitations: {
            ...state.all.group_invitations,
            stats: {
              ...state.all.group_invitations.stats,
              ...action.data.group_invitations.stats
            },
            invites: action.data.group_invitations.invites
          },
          moderation_info: {
            ...state.all.moderation_info,
            ...action.data.moderation_info
          },
          authUser: {
            ...state.all.authUser,
            ...action.data.auth_user
          },
          workplace_invitations: action.data.workplace_invitations,
          loaded: true,
          loading: false
        },
        invitations: {
          ...state.invitations,
          loading: false,
          list: [action.data.mixr_invitations, action.data.group_invitations]
        }
      }
    case mh.GET_MYHOME_MIXR_FUTURE_LIST_REQUEST:
    case mh.GET_MYHOME_MIXR_PAST_LIST_REQUEST:
    case mh.GET_MYHOME_MIXR_FUTURE_LIST_FAILURE:
    case mh.GET_MYHOME_MIXR_PAST_LIST_FAILURE:
      return {
        ...state,
        all: {
          ...state.all,
          pagination: {
            ...state.all.pagination,
            isPagination: false
          }
        }
      }
    case mh.GET_MYHOME_MIXR_FUTURE_LIST_SUCCESS:
      const nextFutureMixrsIds = new Set(action.data.map((m) => m.mixr_id))
      return {
        ...state,
        all: {
          ...state.all,
          pagination: {
            ...state.all.pagination,
            isPagination: false
          },
          future_mixr_list: [
            ...state.all.future_mixr_list.filter((m) => !nextFutureMixrsIds.has(m.mixr_id)),
            ...action.data
          ].sort((a, b) => new Date(a.event_utc_start_datetime) - new Date(b.event_utc_start_datetime))
        }
      }
    case mh.GET_MYHOME_MIXR_PAST_LIST_SUCCESS:
      const nextPastMixrsIds = new Set(action.data.map((m) => m.mixr_id))
      return {
        ...state,
        all: {
          ...state.all,
          pagination: {
            ...state.all.pagination,
            isPagination: false
          },
          past_mixr_list: [
            ...state.all.past_mixr_list.filter((m) => !nextPastMixrsIds.has(m.mixr_id)),
            ...action.data
          ].sort((a, b) => new Date(a.event_utc_end_datetime) - new Date(b.event_utc_end_datetime))
        }
      }
    case mh.GET_MYHOME_SUGGESTED_MIXRS_PAGINATION_REQUEST: {
      return {
        ...state,
        myMixrsLoading: false
      }
    }
    case mh.GET_MYHOME_SUGGESTED_MIXRS_SUCCESS: {
      const nextMixrIds = new Set(action.data.suggested_mixr_list.map((m) => m.id))
      return {
        ...state,
        myMixrsLoading: false,
        all: {
          ...state.all,
          suggested_mixr_list: [
            ...state.all.suggested_mixr_list.filter((m) => !nextMixrIds.has(m.id)),
            ...action.data.suggested_mixr_list
          ].sort((a, b) => new Date(a.event_utc_start_datetime) - new Date(b.event_utc_start_datetime))
        }
      }
    }
    case mh.GET_MYHOME_SUGGESTED_MIXRS_PAGINATION_FAILURE: {
      return {
        ...state,
        myMixrsLoading: false
      }
    }
    case mh.GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST:
      return {
        ...state,
        myMixrsLoading: true
      }
    case mh.GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS:
      const nextPaginationFutureMixrsIds = new Set(action.data.map((m) => m.mixr_id))
      return {
        ...state,
        myMixrsLoading: false,
        all: {
          ...state.all,
          future_mixr_list: [
            ...state.all.future_mixr_list.filter((m) => !nextPaginationFutureMixrsIds.has(m.mixr_id)),
            ...action.data
          ].sort((a, b) => new Date(a.event_utc_start_datetime) - new Date(b.event_utc_start_datetime))
        }
      }
    case mh.GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_FAILURE:
      return {
        ...state,
        myMixrsLoading: false
      }
    case mh.GET_MYHOME_STATS_SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          ...action.data.stats
        }
      }
    case mh.GET_MYHOME_GROUP_LIST_REQUEST:
      return {
        ...state,
        myGroupsLoading: true
      }
    case mh.GET_MYHOME_GROUP_LIST_SUCCESS:
      const nextGroupsIds = new Set(action.data.map((g) => g.group_id))
      return {
        ...state,
        all: {
          ...state.all,
          group_list: [...state.all.group_list.filter((g) => !nextGroupsIds.has(g.group_id)), ...action.data]
        },
        myGroupsLoading: false
      }

    case mh.GET_MYHOME_SUGGESTED_GROUPS_REQUEST: {
      return {
        ...state,
        myGroupsLoading: true
      }
    }
    case mh.GET_MYHOME_SUGGESTED_GROUPS_SUCCESS: {
      const nextGroupsIds = new Set(action.data.suggested_group_list.map((g) => g.group_id))
      return {
        ...state,
        all: {
          ...state.all,
          suggested_group_list: [
            ...state.all.suggested_group_list.filter((g) => !nextGroupsIds.has(g.group_id)),
            ...action.data.suggested_group_list
          ]
        },
        myGroupsLoading: false
      }
    }
    case mh.GET_MYHOME_SUGGESTED_GROUPS_FAILURE: {
      return {
        ...state,
        myGroupsLoading: false
      }
    }
    case mh.UPDATE_RSVP_DATA: {
      const { rsvpData, mixrId } = action
      const isCantGo = rsvpData.attending === 'can_t_go' || rsvpData.attending === 'none'
      const cantGoMixrsIds = new Set(isCantGo ? [mixrId].map((m) => m) : [])
      const updatedFutureMixrList = state.all.future_mixr_list.map((x) => {
        if (x.mixr_id === mixrId) {
          x.user_attending_type = rsvpData.attending
          x.role_group = rsvpData.group_role
          x.groupe_attending = rsvpData.groupe_attending
        }
        if (x.parent_id === rsvpData.parent_id && rsvpData.recurrence_mixr_attending === 'all') {
          x.user_attending_type = rsvpData.attending
          x.role_group = rsvpData.group_role
          x.groupe_attending = rsvpData.groupe_attending
        }
        return x
      })
      const updatedPendingMixrList = state.all.mixr_invitations.invites.map((x) => {
        if (x.mixr_id === mixrId) {
          x.user_attending_type = rsvpData.attending
          x.role_group = rsvpData.group_role
          x.groupe_attending = rsvpData.groupe_attending
        }
        return x
      })
      return {
        ...state,
        all: {
          ...state.all,
          future_mixr_list: [...updatedFutureMixrList.filter((m) => !cantGoMixrsIds.has(m.mixr_id))].sort(
            (a, b) => new Date(a.event_utc_start_datetime) - new Date(b.event_utc_start_datetime)
          ),
          mixr_invitations: {
            ...state.all.mixr_invitations,
            invites: [...updatedPendingMixrList.filter((m) => m.mixr_id !== action.mixrId)].sort(
              (a, b) => new Date(a.event_utc_start_datetime) - new Date(b.event_utc_start_datetime)
            )
          }
        },
        invitations: {
          ...state.invitations,
          list: [
            {
              ...state.invitations.list[0],
              invites: state.invitations.list[0].invites.filter((mixr) => {
                return mixr.mixr_id !== action.mixrId
              })
            },
            state.invitations.list[1]
          ]
        }
      }
    }
    case mh.GET_ALL_INVITATIONS_REQUEST: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          loading: true,
          list: []
        }
      }
    }
    case mh.GET_ALL_INVITATIONS_SUCCESS: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          loading: false,
          list: action.data
        }
      }
    }
    case mh.GET_ALL_INVITATIONS_FAILURE: {
      return {
        ...state,
        invitations: {
          ...state.invitations,
          loading: false,
          list: []
        }
      }
    }
    case groupHomeConstants.JOIN_GROUP_MEMBER_SUCCESS: {
      let updatedGroupList = state.all.suggested_group_list
      let joineGroup = null
      if (action.data.user_attending_status === 'joined') {
        updatedGroupList = updatedGroupList.filter((group) => group.group_id !== action.groupId)
        joineGroup = state.all.suggested_group_list.find((group) => group.group_id === action.groupId)
        if (joineGroup) {
          joineGroup['role'] = 'member'
        }
      } else if (action.data.user_attending_status === 'pending') {
        updatedGroupList = updatedGroupList.map((group) => {
          if (group.group_id === action.groupId) {
            group.group_attending = 'pending'
            return group
          }
          return group
        })
      }
      return {
        ...state,
        all: {
          ...state.all,
          suggested_group_list: updatedGroupList,
          group_list: joineGroup ? [...state.all.group_list, joineGroup] : state.all.group_list
        }
      }
    }

    default:
      return state
  }
}
